<template>
<loading-overlay :active="isLoading" :is-full-page="true" :width="128" :height="128" loader="spinner" color="rgb(var(--color-active-hsl-128))" background-color="rgb(var(--color-b-back))" />
  <SrcBackgroundScroll @scrolled="isShrunk = $event">
    <HeadlineSubScroll 
        :title="$t('settings.update')" 
        target="/Settings" 
        :hassubline="!isShrunk"
        :hasmenu="false"
        :isShrunk="isShrunk"
        >
          <template #icon>
            <IconUpdate             
              class="transition-all duration-300"
              :class="isShrunk ? 'w-8 h-8' : 'w-12 h-12'"/>
          </template>
          <template #subline>
            {{ $t('settings.settingsfor',{wallbox:this.decodeHtml(this.$store.state.WbName)} ) }}
          </template>
    </HeadlineSubScroll>

    <SettingsHeader :admin="this.$store.state.Role=='admin'">
      {{ this.decodeHtml(this.$store.state.WbName) }}
    </SettingsHeader>

    <SettingsBody>
      <template v-slot:formgrid>

          <div class="form-group mb-2 sm:col-span-2">
            <TextfieldWithLabel
              :text="$t('setupdate.installedsw',{version: swversions.linuxVersion })"
            />           
          </div>
          <div v-if="this.$store.state.NewSW" class="form-group mb-2 sm:col-span-2">
          <div class="border-b border-b-4 py-2 font-bold text-lg border-skin-b-list-bord">{{ $t('setupdate.onlineupdate') }}</div>           
          </div>
          <div v-if="this.$store.state.NewSW" class="form-group mb-2">
            <TextfieldWithLabel
              :text="$t('setupdate.newsw',{version: this.$store.state.WbOtiVersion })"
            />            
          </div>
          <div v-if="this.$store.state.NewSW" class="form-group mb-2">
            <TextfieldWithLabel
              :smalltxt="true"
              :text="this.decodeHtml(this.$store.state.WbOtiInfo)"
            />          
          </div>

          <div v-if="this.$store.state.NewSW" class="form-group mb-2 sm:col-span-2">
            <ActionButton @click="uploadtomesh=true;">
              {{ $t('setupdate.downloadinstall',{version: this.$store.state.WbOtiVersion }) }}
            </ActionButton>          
          </div>

          <div v-if="logbox" class="form-group mb-2 sm:col-span-2">
          <div class="border-b border-b-4 py-2 font-bold text-lg border-skin-b-list-bord">{{ $t('setupdate.manualupdate') }}</div>           
          </div>
          <div v-if="logbox" class="form-group mb-2">
            <div class="flex items-center justify-center w-full">
                <label for="dropzone-file" 
                class="flex flex-col items-center justify-center w-full px-4 py-2 sm:h-12
            rounded-lg border-2 border-transparent
            font-semibold text-lg text-skin-b-invt 
            bg-skin-active128
            disabled:opacity-50 disabled:hover:bg-skin-active128 
            hover:bg-skin-active96
            focus:bg-skin-active128 focus:outline-none focus:ring-0 
            active:bg-skin-active128 
            transition duration-300 ease-in-out">
                    <div class="flex flex-col items-center justify-center">
                        <p class="font-semibold text-lg text-skin-b-invt">{{ $t('setupdate.choosefile') }} <span class="text-xs">{{ $t('setupdate.onlytar') }}</span></p>
                    </div>
                    <input id="dropzone-file" type="file" ref="file" @change="onChangeFileUpload()" accept=".tar" class="hidden" />
                </label>
            </div>
          </div>
          <div v-if="logbox" class="form-group mb-2">
            <div class="mb-6 flex" v-if="this.file!=''">
              <div>
                <svg v-if="uploadstatus=='ready'" xmlns="http://www.w3.org/2000/svg" height="48" viewBox="0 96 960 960" width="48">
                  <path fill=rgb(var(--color-text-b-list-base)) d="M220 896q-24 0-42-18t-18-42V693h60v143h520V693h60v143q0 24-18 42t-42 18H220Zm230-153V372L330 492l-43-43 193-193 193 193-43 43-120-120v371h-60Z"/>
                </svg>
                <IconSpinner v-if="uploadstatus=='loading'" class="m-2"/>
                <svg v-if="uploadstatus=='done'" xmlns="http://www.w3.org/2000/svg" height="48" viewBox="0 96 960 960" width="48">
                  <path fill=rgb(var(--color-text-b-list-base)) d="M378 810 154 586l43-43 181 181 384-384 43 43-427 427Z"/>
                </svg>
              </div>
              <div class="ml-2">
                <span class="font-bold text-xl text-skin-b-list-base">{{ filename }}</span>
                <span class="text-skin-b-list-base"> ({{ filesize }} MB)</span>
                <p class="mt-1 text-xs text-skin-b-list-mute dark:text-gray-400">{{ $t('setpublic.lastchanged',{date: filedate }) }}</p>                
              </div>

            </div>
            
            <ActionButton 
            v-if="uploadstatus=='ready'"
            :disabled="this.file==''"
            @click="sendSoftware();restarttimer();">
              {{ $t('setupdate.upload') }}
            </ActionButton>
          </div>

            <div v-if="downloadstatus=='loading'" class="fixed flex justify-center items-center top-0 left-0 right-0 z-50 bg-black/20 overflow-x-hidden overflow-y-auto md:inset-0 h-[calc(100%-1rem)] max-h-full">
              <div class="relative w-full max-w-md max-h-full">
                  <div class="relative bg-white rounded-lg shadow">
                      <div class="p-6 text-center w-full">
                        <IconSpinner class="mx-auto my-4"/>
                        <h3 class="mb-5 text-lg font-semibold">
                          {{ $t('setupdate.swisloading') }}</h3>
                      </div>
                  </div>
              </div>
          </div>

          <div v-if="uploadstatus=='done'||downloadstatus=='done'" class="fixed flex justify-center items-center top-0 left-0 right-0 z-50 bg-black/20 overflow-x-hidden overflow-y-auto md:inset-0 h-[calc(100%-1rem)] max-h-full">
              <div class="relative w-full max-w-md max-h-full">
                  <div class="relative bg-white rounded-lg shadow">
                      <div class="p-6 text-center">
                        <h1 class="mb-5 text-5xl font-semibold">
                            {{counter}} s</h1>
                        <h3 class="mb-5 text-lg font-semibold">
                          {{ $t('setupdate.swloadedinstall') }}</h3>
                      </div>
                  </div>
              </div>
          </div>
          <div v-if="uploadstatus=='restart'||downloadstatus=='restart'" class="fixed flex justify-center items-center top-0 left-0 right-0 z-50 bg-black/20 overflow-x-hidden overflow-y-auto md:inset-0 h-[calc(100%-1rem)] max-h-full">
              <div class="relative w-full max-w-md max-h-full">
                  <div class="relative bg-white rounded-lg shadow">
                    <div class="p-6 text-center w-full">
                          <IconSpinner class="mx-auto my-4"/>
                        <h3 class="mb-5 text-lg font-semibold">
                          {{ $t('setupdate.swloadedrestart') }}</h3>
                      </div>
                  </div>
              </div>
          </div>

          <div v-if="uploadtomesh" class="fixed flex justify-center items-center top-0 left-0 right-0 z-50 bg-black/20 overflow-x-hidden overflow-y-auto md:inset-0 h-[calc(100%-1rem)] max-h-full">
              <div class="relative w-full max-w-md max-h-full">
                  <div class="relative bg-white rounded-lg shadow">
                      <button @click.prevent="submitForm" @click="uploadtomesh=false" type="button" class="absolute top-3 right-2.5 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center">
                          <svg aria-hidden="true" class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd"></path></svg>
                          <span class="sr-only">Close modal</span>
                      </button>
                      <div class="p-6 text-center">
                          <svg aria-hidden="true" class="mx-auto mb-4 w-14 h-14" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg>
                          <h3 v-if="this.$store.state.Mesh" class="mb-5 text-lg font-semibold text-gray-500">
                            {{ $t('setupdate.updatemesh') }}
                          </h3>
                          <h3 v-else class="mb-5 text-lg font-semibold text-gray-500">
                            {{ $t('setupdate.updatewallbox') }}
                          </h3>
                          <button v-if="this.$store.state.Mesh" @click.prevent="submitForm" @click="uploadtomesh=false;downloadSW('all');" type="button" 
                                  class="px-4 py-2 h-12 m-2
                                  rounded-lg border-2 border-transparent
                                  font-semibold text-lg text-skin-b-invt 
                                  bg-skin-active128
                                  disabled:opacity-50 disabled:hover:bg-skin-active128 
                                  hover:bg-skin-active96
                                  focus:bg-skin-active128 focus:outline-none focus:ring-0 
                                  active:bg-skin-active128 
                                  transition duration-300 ease-in-out">
                                  {{ $t('setupdate.confirmupdatemesh') }}
                          </button>
                          <button v-if="this.$store.state.Mesh" @click.prevent="submitForm" @click="uploadtomesh=false;downloadSW(this.$store.state.WbId);" type="button" 
                                  class="px-4 py-2 h-12 m-2
                                  rounded-lg border-2 border-transparent
                                  font-semibold text-lg text-skin-b-invt 
                                  bg-skin-active128
                                  disabled:opacity-50 disabled:hover:bg-skin-active128 
                                  hover:bg-skin-active96
                                  focus:bg-skin-active128 focus:outline-none focus:ring-0 
                                  active:bg-skin-active128 
                                  transition duration-300 ease-in-out">
                                  {{ $t('setupdate.confirmwallboxonly',{wallbox: this.decodeHtml(this.$store.state.WbName) }) }}
                          </button>
                          <button v-else @click.prevent="submitForm" @click="uploadtomesh=false;downloadSW(this.$store.state.WbId);" type="button" 
                                  class="px-4 py-2 h-12 m-2
                                  rounded-lg border-2 border-transparent
                                  font-semibold text-lg text-skin-b-invt 
                                  bg-skin-active128
                                  disabled:opacity-50 disabled:hover:bg-skin-active128 
                                  hover:bg-skin-active96
                                  focus:bg-skin-active128 focus:outline-none focus:ring-0 
                                  active:bg-skin-active128 
                                  transition duration-300 ease-in-out">
                                  {{ $t('setupdate.confirmwallbox',{wallbox: this.decodeHtml(this.$store.state.WbName) }) }}
                          </button>
                          <button @click.prevent="submitForm" @click="uploadtomesh=false;" type="button" 
                                  class="px-4 py-2 h-12 m-2
                                  rounded-lg border-2 border-transparent
                                  font-semibold text-lg text-skin-b-invt 
                                  bg-skin-active128
                                  disabled:opacity-50 disabled:hover:bg-skin-active128 
                                  hover:bg-skin-active96
                                  focus:bg-skin-active128 focus:outline-none focus:ring-0 
                                  active:bg-skin-active128 
                                  transition duration-300 ease-in-out">
                                  {{ $t('common.cancel') }}
                          </button>
                      </div>
                  </div>
              </div>
          </div>

      </template>
    </SettingsBody>
</SrcBackgroundScroll>
</template>

<script>
import SrcBackgroundScroll from './sources/SrcBackgroundScroll.vue'
import HeadlineSubScroll from './elements/HeadlineSubScroll.vue'
import IconUpdate from './icons/IconUpdate.vue'
import SettingsHeader from './elements/SettingsHeader.vue'
import SettingsBody from './elements/SettingsBody.vue'
import ActionButton from './elements/ActionButton.vue'
import TextfieldWithLabel from './elements/TextfieldWithLabel.vue'
import IconSpinner from './icons/IconSpinner.vue'
export default {
  components: {
    SrcBackgroundScroll, HeadlineSubScroll, IconUpdate,
    SettingsHeader, SettingsBody, ActionButton, TextfieldWithLabel,
    IconSpinner
  },  
  data() {
    return {
          isLoading: false,
          file: '',
          filename: '',
          filesize: '',
          filedate: '',
          uploadstatus: 'ready',
          downloadstatus: 'ready',
          uploadtomesh: false,
          swversions: [],
          otiinfo: '',
          counter: 400,
          interval: null,
          pollrestart: null,
          pollingCounter: 5,  // Initial value set to 5 so it triggers on the first run
          isShrunk: false,
    }
  },
  computed: {
    logbox() {
      if(this.$store.state.WbId==this.$store.state.WbLogId)
        return true;
      else
        return false;
    },
  },
  methods: {
    restarttimer() {
        if (this.interval) {
          clearInterval(this.interval);
        }
        if (this.counter === undefined || this.counter === null) {
          this.counter = 400;
        }
        this.interval = setInterval(() => {
          if (this.counter === 0) {
            clearInterval(this.interval);
            this.$router.push({ path: '/' });
          } else {
            this.counter--;

            this.pollingCounter--;
            if (this.pollingCounter === 0) {
              this.pollingFunction();
              this.pollingCounter = 5;
            }
          }
        }, 1000);
    },
    pollingFunction() {
      this.axios
        .get('wallbox/info.php?action=get_version&user='+this.$store.state.token+'&client=-1')
        .then((response) => {        
                    if(response.data.status=='ok'){
                      console.log('Wallbox alive');
                    }else{
                      console.log('Restart Wallbox');
                      clearInterval(this.interval);
                      this.downloadstatus = 'restart';
                      this.pollingRestart();                
                    }
                  })
        .catch((errors) => {
          console.log(errors);
          console.log('Restart Wallbox');
          clearInterval(this.interval);
          this.downloadstatus = 'restart';
          this.pollingRestart();
        });
    },
    pollingRestart() {
      if (this.pollrestart) {
          clearInterval(this.pollrestart);
        }
        this.pollrestart = setInterval(() => {
          this.axios
          .get('wallbox/info.php?action=get_version&user='+this.$store.state.token+'&client=-1')
          .then((response) => {        
                      if(response.data.status=='token'){
                        console.log('Wallbox available');
                        clearInterval(this.pollrestart);
                        //this.$router.push({ path: '/' });
                        window.location.replace('https://'+this.$store.state.WbLogIp+'/index.html');
                      }else{
                        console.log('Booting Wallbox');                
                      }
                    })
          .catch((errors) => {
            console.log(errors);
            console.log('Booting Wallbox');
          });
          
        }, 5000);
    },    
    decodeHtml: function(html) {
      let txt = document.createElement("textarea");
      txt.innerHTML = html;
      return txt.value;
    },
    sendSoftware(){
        this.uploadstatus='loading';
        let formData = new FormData();
        formData.append('fileToUpload', this.file);
        formData.append('user', this.$store.state.token);
        formData.append('action', 'update_file');       

        this.axios.post('wallbox/update.php',

            formData,
            {
            headers: {
                'Content-Type': 'multipart/form-data'
                }
            }
        ).then((response) => {
          if(response.data.status=='ok'){
            this.uploadstatus = 'done';
          }else{
            this.uploadstatus = 'ready';
          }
        })
        .catch((errors) => {
                  console.log(errors); // Errors
        });
      },
      downloadSW(client){
        this.downloadstatus = 'loading';
        this.axios
        .get('wallbox/update.php?action=update_online&user='+this.$store.state.token+'&client='+client)
        .then((response) => {        
                    if(response.data.status!=''){
                      this.downloadstatus = 'done';
                      this.restarttimer();
                      console.log('Hochgeladen');
                    }else{
                      console.log('Error get Online Update');                   
                    }
                  })
        .catch((errors) => {
          console.log(errors); // Errors
        });
      },
      onChangeFileUpload(){
        const selectedFile = this.$refs.file.files[0];
        if (selectedFile && selectedFile.name.endsWith('.tar')) {
            this.file = selectedFile;
        } else {
            alert('Please upload a .tar file.');
            this.file = ''; // Reset the file
        }
        this.filename = this.file.name;
        this.filesize = ((this.file.size)/1000000).toFixed(2);
        this.filedate = this.$dayjs(this.file.lastModified).format('DD.MM.YYYY HH:mm');
      }
  },
  created() {
    this.isLoading = true;
    let SoftwareVersionUrl = 'wallbox/info.php?action=get_version&user='+this.$store.state.token+'&client='+this.$store.state.WbId;
    const requestSoftwareVersion = this.axios.get(SoftwareVersionUrl);
    this.axios
          .all([requestSoftwareVersion])
          .then(
            this.axios.spread((...responses) => {
                const responseSoftwareVersion = responses[0];

                if(responseSoftwareVersion.data.status=='token'){
                        this.$router.push({path: '/'});                         
                }else if(responseSoftwareVersion.data.status=='ok'){
                  this.swversions = responseSoftwareVersion.data.tbl_version; 
                }else{
                  console.log('Error get Softwareversions');
                }
            this.isLoading = false;
            })
        )
        .catch((errors) => {
            this.isLoading = false;
            console.error(errors);
        });
  },
};
</script>

<style scoped>
</style>
